import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  strict: true,
  bmode: 'hash',
  routes: [
    {
      path: '/',
      component: () => import('@/views/landing/Login'),
    },
    {
      path: '/forgot_password',
      component: () => import('@/views/landing/Forgot_pass'),
    },
    {
      path: '*',
      component: () => import('@/views/account/Sorry'),
    }, 
    {
      meta: {
        requiresAuth: true,
      },
      path: '/account',
      name: 'Home',
      component: () => import('@/views/Platform'),
      children: [
        {
          name: 'Maps',
          path: '/account/dashboard',
          component: () => import('@/views/account/Dashboard'),
        }, 
        {
          name: 'Asset Info.',
          path: '/account/asset_info',
          component: () => import('@/views/account/Asset_info'),
        },
        ,
        {
          name: 'Track',
          path: '/account/track',
          component: () => import('@/views/account/Track'),
        },
        {
          name: 'Trips',
          path: '/account/trips',
          component: () => import('@/views/account/Trips'),
        },
        {
          name: 'Alerts',
          path: '/account/alerts',
          component: () => import('@/views/account/Alerts'),
        },
        {
          name: 'Fuel',
          path: '/account/fuel',
          component: () => import('@/views/account/Fuel'),
        },
        {
          name: 'Reports',
          path: '/account/reports',
          component: () => import('@/views/account/Reports'),
        },
        {
          path: '/account/changepassword',
          component: () => import('@/views/account/Change_password'),
        }, 
      ],
    },
  ],
})
